export const SET_USER = 'SET_USER';
export const FETCH_USER_REQUEST = 'FETCH_USER_REQUEST';
export const FETCH_USER_FAIL = 'FETCH_USER_FAIL';
export const SET_TOKEN = 'SET_TOKEN';
